export default __webpack_public_path__ + "static/media/leumi-header.188a0a82.png";